<template>
  <div class="footer-accordion"
       :class="{open: disclaimerOpen}">
    <div class="footer-wrapper">
      <div class="footer clearfix">

        <nav class="nav nav-footer">
          <ul class="level-1">
            <li><a :href="$t('footer:nav.aboutUBS.url')" target="_blank">{{ $t('footer:nav.aboutUBS.label') }}</a></li>
            <li><a :href="$t('footer:nav.termsOfUse.url')" target="_blank">{{ $t('footer:nav.termsOfUse.label') }}</a></li>
            <li><a :href="$t('footer:nav.privacy.url')" target="_blank">{{ $t('footer:nav.privacy.label') }}</a></li>
            <li><a :href="$t('footer:nav.reportEmail.url')" target="_blank">{{ $t('footer:nav.reportEmail.label') }}</a></li>
            <li><a :href="$t('footer:nav.legal.url')" target="_blank">{{ $t('footer:nav.legal.label') }}</a></li>
            <li><a :href="$t('footer:nav.cookies.url')" target="_blank">{{ $t('footer:nav.cookies.label') }}</a></li>
          </ul>
        </nav>

        <div class="disclaimer clear" v-html="$t('footer:disclaimer')"></div>

        <div class="copyright">{{ $t('footer:copyright') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {
            disclaimerOpen: true
        }
    }
}
</script>
